import * as React from 'react';
import { useState } from 'react';
import Box from '@mui/material/Box';
import { CertificateModel } from 'model/screensModels/CertificateModel';
import UploadCertificate from './UploadCertificate';
import CertificateList from './CertificateList';

export default function Certificate() {
  const [updateValue, setUpdateValue] = React.useState(new CertificateModel());
  const [flag, setFlag] = useState(false);
  const [isEditMode, setIsEditMode] = useState(false);

  const setIndex = (index: number) => {

  };

  const getUpdateRecordValue = (certificateModel: CertificateModel) => {
    setIsEditMode(true);
    setUpdateValue(certificateModel);
  };

  const uploadCertificate = () => {
    setUpdateValue(new CertificateModel())
    setIsEditMode(false); // Reset edit mode
    setFlag(true);
  }

  return (
    <>
      <Box sx={{ width: '100%' }} className="container container-h-full">
        <Box>
      
          <div className="content-subheader">
            {!flag ? (
              <h2 className="mr-3 font-weight-bolder">Certificate List</h2>
            ) : (
              <h2 className=" font-weight-bolder mr-3">{isEditMode ? 'Edit Certificate' : 'Upload Certificate'}</h2>
            )}
            {!flag && <button className="btn primary" onClick={uploadCertificate}>Upload Certificate</button>}
          </div>
        </Box>
        <div className="sub-content-sec recently-blog">
          {!flag ?
            <CertificateList
              setFlag={setFlag}
              updateRecord={getUpdateRecordValue}
              setIndex={setIndex}
            />
            :
            <UploadCertificate
              setFlag={setFlag}
              updateRecord={updateValue}
              setIndex={setIndex}
            />
          }
        </div>
      </Box>
    </>
  );
}